import type { ListingDetails } from 'app/types/listingDetails.type';
import merge from 'lodash/merge';

type SortBy = 'added' | 'lowPrice' | 'highPrice' | 'updated';

interface GetSortedListingsParams {
  listings: Array<ListingDetails>;
  sortBy: SortBy;
}

const controller = {
  getSortedListings({ listings, sortBy }: GetSortedListingsParams): Array<ListingDetails> {
    const _listings = merge([], listings) as Array<ListingDetails>;
    if (sortBy === 'added') {
      return _listings;
    } else if (sortBy === 'lowPrice') {
      return _listings.sort((a, b) => {
        return a.listingMinMaxPriceBeds.minPrice - b.listingMinMaxPriceBeds.minPrice;
      });
    } else if (sortBy === 'highPrice') {
      return _listings.sort((a, b) => {
        return b.listingMinMaxPriceBeds.minPrice - a.listingMinMaxPriceBeds.minPrice;
      });
    } else if (sortBy === 'updated') {
      return _listings.sort((a, b) => {
        return b.updated - a.updated;
      });
    }
    // TypeScript requires all code paths to return a value
    return _listings;
  },
};

export default controller;
